'use strict';

import axios from 'axios';

export default class BaseApi {
  constructor(type) {
    this.endpoint = document.querySelector('meta#aukanaApiEndpoint').getAttribute('content');
    this.headers = {
      'Content-Type':'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    };
  }

  getApiRequest(uri, params = {}) {
    const axiosApi = axios.create({
      headers: this.headers
    });

    params['uri'] = encodeURIComponent(uri);

    return axiosApi.get(this.endpoint, { params: params })
      .then(function (response) {
        return response['data'];
      })
      .catch(function (error) {
        console.log(error);
        return [];
      });
  }

  postApiRequest(uri, params = {}) {
    const axiosApi = axios.create({
      headers: this.headers
    });

    params['uri'] = encodeURIComponent(uri);

    return axiosApi.post(this.endpoint, JSON.stringify(params))
      .then(function (response) {
        return response['data'];
      })
      .catch(function (error) {
        console.log(error);
        return [];
      });
  }
}